import React from "react";
import styled from 'styled-components';
import InputSubTitleClaroSocio from '../../../molecules/InputSubtitleClaroSocio';
import InputTitleClaroSocio from '../../../molecules/InputTitleClaroSocio';
import ClaroImage from '../../../molecules/ClaroImage'
import ClaroInputField from "../../../atoms/ClaroInputField";
import ClaroDiv from "../../../atoms/ClaroDiv";
import ClaroInputButton from "../../../atoms/ClaroInputButton"
import { validationStyles } from '../utils/index'
import { ARCUS_BILLER_IDS } from "../../../../constants";
import {
    SERVICE_ID_TELCEL_POSPAGO,
    SERVICE_ID_TELCEL_PLANES,
    AMIGO_PAGUITOS,
    SERVICE_ID_TELCEL_RECARGA
  } from '../../../../constants';
import { getFavoritosRef, addFavoritesRef, deleteFavoritesRef } from '../../../../store/actions/favoritosRef';
import { executeTaggeo } from "../../../../store/actions";
import { getTagServiceId, getListFavsServices, getCanManageFavorites } from '../../../../store/selectors/paymentsSelectors';
import CreateFavoriteService from "../../../molecules/createFavoriteService";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const Container = styled.div`
    width: 100%%;
    background: ${props => props.background ? props.background : "#fff"};
    margin: ${props => props.margin ? props.margin : "2%"};
`;

export default class DefaultInputClaroSocio extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            isFocused: false,
            phoneNumber: undefined,
            alias: undefined,
            saveCard: false,
            value:undefined
        }
    }

    componentDidMount() {
        if(this.props.favoritos && !this.props.isContainerTelcel && this.props.canManageFavorites){
            this.assignTagServiceTelcel(this.props.serviceId);
        }
    }

    componentDidUpdate(prevProps,prevState) {
        if(this.props.favoritos && !this.props.isContainerTelcel && this.props.canManageFavorites){
        if(!this.state.alias && this.state.phoneNumber && !this.state.saveCard && this.props.listFavServices !== undefined){
          this.handleAsignPhone();
        }
        if(this.props.value && this.props.value !== prevProps.value){
            if(!this.props.listFavServices){
                this.props.getFavoritosRef('findFavoriteMicroApp', this.props.tagServiceId);
            }
            this.handleValidateLength(this.props.value,this.props.input);      
          }

          if(!this.props.value && this.props.value !== prevProps.value){
            this.props.handleInputChange({target:{ name:this.props.input.field.input.name, value: this.props.value}}, this.props.input.type);
            this.setState({ alias: undefined });   
            this.setState({ phoneNumber: undefined }); 
            if(!this.props.listFavServices){
                this.props.getFavoritosRef('findFavoriteMicroApp', this.props.tagServiceId);
            }
          }

          if(this.props.hasFavsSuccess.alias && this.props.hasFavsSuccess.alias !== prevProps.hasFavsSuccess.alias){
            if(this.props.value === this.props.hasFavsSuccess.accountService){
                this.setState({ alias: this.props.hasFavsSuccess.alias });
            }
        }
        }
        
    }

    assignTagServiceTelcel(serviceId) {
        let newTagServiceId;
    
        switch (true) {
            case (serviceId === SERVICE_ID_TELCEL_PLANES):
                newTagServiceId = 'telcelAmigoSinLimitePs';
                break;
            case (serviceId === SERVICE_ID_TELCEL_POSPAGO):
                newTagServiceId = 'TelcelPospagoPS';
                break;
            case (serviceId === AMIGO_PAGUITOS):
                newTagServiceId = 'amigopaguitos';
                break;
            case (serviceId === SERVICE_ID_TELCEL_RECARGA):
                newTagServiceId = 'serviciopagotelcel';
                break;
            default:
                newTagServiceId = this.props.tagServiceId;
        }
    
        if (this.state.tagServiceId !== newTagServiceId) {
          this.setState({ tagServiceId: newTagServiceId })
          if(!this.props.canPaymentReminder){
          this.props.getFavoritosRef('findFavoriteMicroApp', newTagServiceId);
          }else{
            this.props.getPaymentReminder();
          }
          };
    }

    handleImagenClick = () => {
        this.props.executeTaggeo({
            action: "Click Guardar Servicio",
            step: "Formulario de pago",
            service: this.props.tagServiceId,
        })
        this.setState({ saveCard: true });
    };

    handleCloseModal = (props) => {
        this.setState({ saveCard: false })
        this.props.getFavoritosRef('findFavoriteMicroApp', this.props.tagServiceId);
    }

    handleValidateLength = (e,input) =>{
        let inputNumber
        if(!this.props.value){
            inputNumber = e.target.value
          }else{
              if(this.props.fromListFavorites){
                  this.props.handleInputChange({target:{ name:this.props.input.field.input.name, value: this.props.value}}, this.props.input.type);
              }
              inputNumber = e;
          }
        const {isValid,isContainerTelcel,isClaroPartner,canManageFavorites,favoritos,serviceId,serviceInfo,tagServiceId} = this.props;
        const {phoneNumber,alias,saveCard,isFocused} = this.state;
        if(favoritos && !isContainerTelcel && canManageFavorites && !this.props.isClaroPartner){
            if(serviceInfo.multipleServiceIds && serviceInfo.multipleServiceIds.ocr.referenceLength){
                if (e.length >= serviceInfo.multipleServiceIds.ocr.referenceLength || e.length === serviceInfo.multipleServiceIds.manual.referenceLength) {
                    const trimmedValue = e.slice(0, input.field.input.truncateValue);
                    this.setState({ phoneNumber: trimmedValue });
                    this.setState({ alias: undefined });
                } else {
                    this.setState({ phoneNumber: undefined, alias: undefined });
                }
            }else if(tagServiceId === 'psPase'){
                if (e.length === 12 || e.length >= 13) {
                    const trimmedValue = e.slice(0, input.field.input.truncateValue);
                    this.setState({ phoneNumber: trimmedValue });
                    this.setState({ alias: undefined });
                } else {

                    this.setState({ phoneNumber: undefined, alias: undefined });
                }
            }else if(tagServiceId === 'TeleviaPS' ){
                if (e.length === 11 || e.length >= 12) {
                    const trimmedValue = e.slice(0, input.field.input.truncateValue);
                    this.setState({ phoneNumber: trimmedValue });
                    this.setState({ alias: undefined });
                } else {

                    this.setState({ phoneNumber: undefined, alias: undefined });
                }
            }else if(tagServiceId === 'TotalplayPS' ){
                if (e.length === 10 || e.length >= 17) {
                    const trimmedValue = e.slice(0, input.field.input.truncateValue);
                    this.setState({ phoneNumber: trimmedValue });
                    this.setState({ alias: undefined });
                } else {

                    this.setState({ phoneNumber: undefined, alias: undefined });
                }
            }else{
                if (e.length >= input.field.input.truncateValue) {
                    const trimmedValue = e.slice(0, input.field.input.truncateValue);
                    this.setState({ phoneNumber: trimmedValue });
                    this.setState({ alias: undefined });
                } else {

                    this.setState({ phoneNumber: undefined, alias: undefined });
                }
            }
        
    }
    }

    handleAsignPhone = () =>{
        const foundService = this.props.listFavServices.find(service => {
            return service.accountService === this.state.phoneNumber;
        })
        if (foundService) {
            const foundValue = foundService["alias"];
            this.setState({ alias: foundValue });
        }
    }


    render() {
        const {isValid,isContainerTelcel,isClaroPartner,canManageFavorites,favoritos,serviceId,serviceInfo,tagServiceId} = this.props;
        const {phoneNumber,alias,saveCard,isFocused} = this.state;
        let validation = validationStyles(isValid, isContainerTelcel, isClaroPartner);
        let input = this.props.input;
        if (input && input.field.button && isContainerTelcel && !isClaroPartner) {
            input.field.button = {
                ...input.field.button,
                src: "/images/icono_ocr.png",
                width: "28px",
                height: "28px"
            }
        }
        const styles = {
            "color": validation.validInvalidColor,
            "borderBottom": isContainerTelcel && isFocused && isValid ? "1px solid #0071d1" : validation.borderValidInvalidColor,
            "textTransform": (input.field.input.style && input.field.input.style.textTransform) ? input.field.input.style.textTransform : "initial"
        }
        let id = "pagoDeServicios_" + input.id + "_" + this.props.serviceName;
    
        let value = (this.props.setDefaultValue) ? input.field.input.value : this.props.value;
        let readonly = (input.field.input.disabled) ? true : false;
        let stylesTitle = input.title;

        if (this.props.isClaroPartner && input.name == "amount") {
            stylesTitle = ""

        }        

        return (
            <Container
                background={isContainerTelcel && !isClaroPartner ? "#fff" : undefined}
                margin={isContainerTelcel && !isClaroPartner ? "2% 2% 15px 2%" : undefined}>
                <InputTitleClaroSocio
                    {...stylesTitle}
                    type={input.type}
                    handleClickTooltip={this.props.handleClickTooltip}
                    isClaroPartner={isClaroPartner}
                    isContainerTelcel={isContainerTelcel}
                    isFocused={isFocused}
                />
                <ClaroDiv  {...styles}>
                    <ClaroInputField
                        {...styles}
                        value={value}
                        onChange={(e) => {
                            this.props.handleInputChange(e, input.type);
                        }}
                        name={input.field.input.name}
                        placeholder={input.field.input.placeholderCPay && !isContainerTelcel && !isClaroPartner ? input.field.input.placeholderCPay : input.field.input.placeholder}
                        id={id}
                        type={input.field.input.type}
                        readOnly={readonly}
                        onFocus={() => this.setState({ isFocused: true })}
                        onBlur={() => this.setState({ isFocused: false })}
                        phColor={isContainerTelcel && !isClaroPartner ? "#757575" : "#c4c4c4"}
                        fontFamily={isContainerTelcel && !isClaroPartner ? "AMX-Regular" : undefined}
                        fontSize={isContainerTelcel && !isClaroPartner ? "14px" : undefined}
                    />
                    {this.state.phoneNumber &&(

                        <>
                            {alias &&  phoneNumber.length<= 29 && (
                                <p style={{ position: 'absolute', fontSize:'13px', right: '20px', top: '0%', color:'#a6ce4e', transform: 'translateY(-50%)' }}>
                                    {alias}
                                </p>
                            )}


                            {!alias &&  phoneNumber.length<= 29 &&(
                               <p
                               style={{
                                   position: 'absolute',
                                   right: '16px',
                                   fontSize:'14px',
                                   top: '10%',
                                   padding: '1px',
                                   transform: 'translateY(-50%)',
                                   color: '#329ebc', 
                                   fontWeight: 'bold', 
                                   textDecoration: 'underline', 
                               }}
                               onClick={this.handleImagenClick} 
                           >
                               Guardar Servicio
                           </p>
                            )}

                            {alias && phoneNumber.length>= 30 &&(
                                <p style={{ position: 'absolute', fontSize:'13px', right: '0px', top: '0%', color:'#a6ce4e', transform: 'translateY(-50%)' }}>
                                    {alias}
                                </p>
                            )}


                            {!alias && phoneNumber.length>= 30 &&(
                               <p
                               style={{
                                   position: 'absolute',
                                   right: '0px',
                                   fontSize:'14px',
                                   top: '10%',
                                   padding: '1px',
                                   transform: 'translateY(-50%)',
                                   color: '#329ebc', 
                                   fontWeight: 'bold', 
                                   textDecoration: 'underline', 
                               }}
                               onClick={this.handleImagenClick} 
                           >
                               Guardar Servicio 
                           </p>
                            )}
                        </>
                    )}
                    {
                        (   
                            input.field.button &&
                            (
                                (!ARCUS_BILLER_IDS.includes(serviceId) && 
                                !isContainerTelcel && 
                                !this.props.favoritos) || isContainerTelcel
                            )
                        ) ? (
                            <ClaroInputButton
                                borderBottom={isFocused && isValid ? "1px solid #0071d1" : validation.borderValidInvalidColor}
                                {...input.field.button}
                                onClick={(e) => { this.props.handleInputButtonFunction(e, input.type) }}
                            >
                                <ClaroImage {...input.field.button} isClaroPartner={isClaroPartner} />
                            </ClaroInputButton>
                        ) : (<></>)
                    }
                </ClaroDiv>
                <InputSubTitleClaroSocio {...input.subTitle} type={input.type} />
                {saveCard && (
                    <CreateFavoriteService
                    configImgService={this.props.configImgService}
                    isFavoriteServices={true}
                    tagServiceId={tagServiceId}
                    accountService={phoneNumber}
                    isContainerTelcel={isContainerTelcel}
                    closeModalFavoriteServices={this.handleCloseModal}
                    hasFavs={true}
                    />
                )}
            </Container>

        )
    }
}

function mapStateToProps(state) {
    const { payments, favoritesRefReducer } = state;
    const tagServiceId = getTagServiceId(payments);
    const listFavServices = getListFavsServices(favoritesRefReducer)
    return {
        favoriteServices: state,
        tagServiceId,
        listFavServices,
        hasFavsSuccess: state.favoritesRefReducer.ResponseSuccess,
        isLoadingGetFavServices: state.favoritesRefReducer.isLoading,
        canManageFavorites: payments.canManageFavorites
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getFavoritosRef,
            deleteFavoritesRef,
            executeTaggeo
        },
        dispatch
    );
}

DefaultInputClaroSocio = connect(
    mapStateToProps,
    mapDispatchToProps
)(DefaultInputClaroSocio);